module.exports = __webpack_public_path__ + "img/pazarplus-main-card.2cc6a041.jpg";